module.exports = __webpack_public_path__ + "img/2018.64beb12d.webp";